export enum TransportMethod {    
    Unknown = 0,
    Commercial = 1,
    Ground = 2,
    Internal = 3,
    Charter = 4,
    CommObc = 5,
    CharterComm = 6,
    CommCharter = 7,
    CommOneLegObc = 8
}